export function normalizeAiConfidence(confidence?: number | null) {
	if (confidence === null || confidence === undefined) return 0;
	if (!Number.isFinite(confidence) || confidence <= 0) return 0;

	const score = confidence <= 1 ? confidence * 100 : confidence;

	return Math.min(Math.round(score), 100);
}
